export enum Roles {
  SuperAdmin = 'SuperAdmin',
  MultiAdmin = 'MultiAdmin',
  Admin = 'Admin',
  Manager = 'Manager',
  Instructor = 'Instructor',
  Creator = 'Creator',
  Player = 'Player',
}
